export default __webpack_public_path__ + "static/media/near-protocol-near-logo.136739ba.svg";